export var wixImageToProGallery = function wixImageToProGallery(wixImage) {
  var dataId = wixImage.dataId,
      title = wixImage.title,
      description = wixImage.description,
      image = wixImage.image;
  var uri = image.uri,
      width = image.width,
      height = image.height,
      link = image.link;
  return {
    itemId: dataId,
    mediaUrl: uri,
    orderIndex: 0,
    metaData: {
      type: 'image',
      height: height,
      width: width,
      title: title,
      description: description,
      sourceName: 'private',
      link: {
        url: link == null ? void 0 : link.href,
        type: 'web',
        target: link == null ? void 0 : link.target
      }
    }
  };
};
export var proGalleryToWixImage = function proGalleryToWixImage(item) {
  var itemId = item.itemId,
      mediaUrl = item.mediaUrl,
      metaData = item.metaData;
  var height = metaData.height,
      width = metaData.width,
      title = metaData.title,
      description = metaData.description,
      link = metaData.link;
  var url = link.url,
      target = link.target;
  return {
    dataId: itemId,
    title: title,
    description: description,
    image: {
      uri: mediaUrl,
      width: width,
      height: height,
      link: {
        href: url,
        target: target
      }
    }
  };
};